import validate from 'validate.js';
import { get } from 'lodash';

const validateBaseRate = (values) => {
  const { value } = get(values, 'prices', '');
  return {
    prices: {
      value: validate.single(value,
        {
          presence: { allowEmpty: false },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            lessThanOrEqualTo: 99000
          }
        })
    }
  };
};

export default validateBaseRate;
